import React from "react";

import styled from "styled-components";
import { Box, Flex } from "reflexbox/styled-components";
import { Button } from "antd";

import TitleSeparator from "../components/title-separator/TitleSeparator";
import Map from "./Map";
import LocationMountainButton from "../components/buttons/mountain-button/LocationMountainButton";
import { withLocalizeStrings } from "../languages/Localize";

import jefWall from "../assets/images/jahorina-wall.jpg";
import termagLogo from "../assets/images/termag-logo-veliki.png";
import phoneSvg from "../assets/images/phone.svg";
import mailSvg from "../assets/images/mail.svg";
import globeSvg from "../assets/images/globe.svg";
import { checkIfIOS } from "../util/util";

const StyledContainer = styled(Flex)`
    width: 100%;
    height: 100%;
    flex-direction: column;
`;

const StyledBackgroundAndTitleContainer = styled(Flex)`
    width: 100%;
    height: 50%;
    top: 0;
    position: absolute;
`;

const StyledBackgroundImage = styled(Box)`
    background: url(${jefWall}) no-repeat center / cover;
    width: 100%;
`;

const StyledShade = styled(Flex)`
    position: absolute;
    bottom: 0;
    left: 0;
    background: linear-gradient(to top, #1a3752f0 0%, #564c8f1a 100%);
    width: 100%;
    height: 20%;
    align-items: center;
    .title {
        position: relative;
        left: 45%;
        color: white;
        font-weight: 700;
        font-size: 17px;
        ${({ theme }) => theme.mediaQueries.medium} {
            font-size: 22px;
        }
    }
`;

const StyledHotelContainer = styled(Flex)`
    height: 50%;
    width: 100%;
    position: relative;
`;

const StyledMap = styled(Flex)`
    flex: 1;
    width: 100%;
    ${({ theme }) => theme.mediaQueries.small} {
        height: 33%;
    }
`;

const StyledHotelLinks = styled(Flex)`
    position: absolute;
    // bottom: 20%;
    bottom: 15%;
    left: 20px;
    flex-direction: column;
    justify-content: space-between;
`;

const StyledLogoContainer = styled(Flex)`
    background-color: white;
    border-radius: 5px;
    min-height: 60px;
    width: 120px;
    padding: 4px 0;
    justify-content: center;
    align-items: center;
    .logo-img {
        padding: 4px;
        width: 90%;
        height: auto;
    }
    ${({ theme }) => theme.mediaQueries.small} {
        min-height: 100px;
    }
`;

const StyledButton = styled(Button)`
    background-color: white;
    border-radius: 5px;
    height: 24px;
    width: 24px;
    &.ant-btn {
        ${({ theme }) => theme.mediaQueries.smallMax} {
            padding: 0 12px;
        }
    }
    ${({ theme }) => theme.mediaQueries.small} {
        height: 28px;
        width: 28px;
    }

    &.phone {
        background: url(${phoneSvg}) ${({ theme }) => theme.colors.white} no-repeat center;
        background-size: 20px 20px;
        ${({ theme }) => theme.mediaQueries.small} {
            background-size: 24px 24px;
        }
    }
    &.mail {
        background: url(${mailSvg}) ${({ theme }) => theme.colors.white} no-repeat center;
        background-size: 20px 20px;
        ${({ theme }) => theme.mediaQueries.small} {
            background-size: 24px 24px;
        }
    }
    &.globe {
        background: url(${globeSvg}) ${({ theme }) => theme.colors.white} no-repeat center;
        background-size: 20px 20px;
        ${({ theme }) => theme.mediaQueries.small} {
            background-size: 24px 24px;
        }
    }
`;

const StyledHotelInfo = styled(Flex)`
    position: absolute;
    top: 50%;
    left: 45%;
    flex-direction: column;
    justify-content: space-evenly;
    font-size: 9px;
    ${({ theme }) => theme.mediaQueries.medium} {
        font-size: 11px;
    }
`;

const StyledInfoText = styled(Flex)`
    flex-direction: column;
    font-size: 10px;

    ${({ theme }) => theme.mediaQueries.small} {
        font-size: 12px;
    }

    color: white;
    a {
        text-decoration: none;
        color: ${({ theme }) => theme.colors.white};
    }
`;

const StyledButtonContainer = styled(Flex)`
    width: 120px;
    margin-top: 8px;
    justify-content: space-between;
`;

const StyledMapLink = styled(Box)`
    position: absolute;
    bottom: 90px;
    right: 20px;
    background: ${({ theme: { colors } }) => colors.primary};
    border-radius: 10px;
    padding: 6px;
    background: linear-gradient(135deg, #ff4070, #210d7b);
`;

const StyledOpenMapLink = styled.a`
    color: #fff;

    &:hover,
    &:active {
        color: #dbcccc;
    }
`;

const Location = ({ strings, history }) => {
    const openMapsApp = () => {
        window.open("geo://" + 43.7353095 + "," + 18.5658001 + "?q=" + encodeURIComponent("Hotel Termag"), "_system");
    };

    return (
        <StyledContainer>
            <TitleSeparator>{strings.location.HEADER}</TitleSeparator>

            <StyledHotelContainer>
                <StyledBackgroundAndTitleContainer>
                    <StyledBackgroundImage />
                    <StyledShade>
                        <Box className="title">{strings.location.HOTEL_TITLE}</Box>
                    </StyledShade>
                </StyledBackgroundAndTitleContainer>
                <StyledHotelLinks>
                    <StyledLogoContainer>
                        <img src={termagLogo} alt="" className="logo-img" />
                    </StyledLogoContainer>
                    <Box width="120px" marginTop="8px">
                        <LocationMountainButton path={`web:${strings.location.RESERVATIONS_WEB_ADDRESS}`}>
                            {strings.location.BTN_RESERVATIONS}
                        </LocationMountainButton>
                    </Box>
                    <StyledButtonContainer>
                        <StyledButton className="phone">
                            <a href={`tel:${strings.location.TEL_1}`}>&nbsp;</a>
                        </StyledButton>
                        <StyledButton className="mail">
                            <a href={`mailto:${strings.location.MAIL}`}>&nbsp;</a>
                        </StyledButton>
                        <StyledButton className="globe">
                            <a href={`web:${strings.location.WEB_ADDRESS}`}>&nbsp;</a>
                        </StyledButton>
                    </StyledButtonContainer>
                    {/*<Box width="120px" marginTop="8px">
                        <StyledButton className="globe">
                            <a href={`geo:37.786971,-122.399677;u=35`}>&nbsp;</a>
                        </StyledButton>
                    </Box>*/}
                </StyledHotelLinks>
                <StyledHotelInfo>
                    <StyledInfoText>
                        <Box>{strings.location.ADDRESS}</Box>
                        <Box>
                            <a href={`tel:${strings.location.TEL_1}`}>{strings.location.TEL_1}</a>
                        </Box>
                    </StyledInfoText>
                    <StyledInfoText>
                        <Box>
                            <a href={`tel:${strings.location.TEL_2}`}>{strings.location.TEL_2}</a>
                        </Box>
                        <Box>
                            <a href={`mailto:${strings.location.MAIL}`}>{strings.location.MAIL}</a>
                        </Box>
                        <Box>
                            <a href={`web:${strings.location.WEB_ADDRESS}`}>{strings.location.SHOWN_WEB_ADDRESS}</a>
                        </Box>
                    </StyledInfoText>
                </StyledHotelInfo>
            </StyledHotelContainer>
            <StyledMap onClick={openMapsApp}>
                <Map
                    onClick={openMapsApp}
                    isMarkerShown
                    googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyA8YaQ92tDm2wyOLbXCFOScLNUdhUX5ThQ&v=3.exp&libraries=geometry,drawing,places"
                    loadingElement={<div style={{ height: `100%`, width: `100%` }} />}
                    containerElement={<div style={{ height: `100%`, width: `100%` }} />}
                    mapElement={<div style={{ height: `100%`, width: `100%` }} />}
                />
                {checkIfIOS() && (
                    <StyledMapLink>
                        <StyledOpenMapLink href="http://maps.apple.com/?q=Termag+Hotel&sll=43.7353095,18.5658001&z=17&t=s">
                            {strings.location.openLocation}
                        </StyledOpenMapLink>
                    </StyledMapLink>
                )}
            </StyledMap>
        </StyledContainer>
    );
};
export default withLocalizeStrings(Location);
